export default {
      id: "color_health_wgs-usage",
      viewBox: "0 0 70 69",
      url: __webpack_public_path__ + "sprite.svg#color_health_wgs",
      toString: function () {
        return this.url;
      }
    }